// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"734":"d801e08d","845":"a1f971d0"}[chunkId] + ".chunk.js";
};